import { render, staticRenderFns } from "./OrderListModal.vue?vue&type=template&id=07c6c165&scoped=true"
import script from "./OrderListModal.vue?vue&type=script&lang=js"
export * from "./OrderListModal.vue?vue&type=script&lang=js"
import style0 from "./OrderListModal.vue?vue&type=style&index=0&id=07c6c165&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c6c165",
  null
  
)

export default component.exports